<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title page-title">
      <p>调查问卷结果</p>
      <span @click="backPre">返回</span>
    </div>
    <div class="panel-content center_content">
      <div class="course_info">
        <div class="panel-title">
          <p v-if="lessonInfo">{{ lessonInfo ? lessonInfo.title : '' }}</p>
          <p v-if="lessonInfo">负责人:{{ managerName }}</p>
        </div>
      </div>
      <div class="list">
        <h2>{{ surveyInfo ? surveyInfo.title : '' }}</h2>
        <hr>
        <ul>
          <li
            v-for="(question, index) in questions"
            :key="index"
          >
            <div>
              <span class="question-title">{{ index + 1 }}.</span>
              <span
                class="question-title"
                v-html="question.content"
              ></span>
            </div>
            <div>
              <ul class="question-list">
                <li
                  v-for="(option, op_index) in question.options"
                  :key="op_index"
                >
                  {{ option.code }}. {{ option.title }}
                  <span>{{ getPercent(question.id, option.code) }}</span>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnlineResearchResult',
  props: [
    'lessonInfo'
  ],
  data() {
    return {
      surveyInfo: null,
      allQuestion: [],
      allOption: [],
      studentCount: 0,
      studentOption: []
    }
  },
  methods: {
    async search () {
      await this.$http.get('/online_survey/' + this.$route.query.survey_id + '/').then((data) => {
        this.surveyInfo = data
      })

      if (this.surveyInfo) {
        await this.$http.get('/online_survey_question/', {
          params: {
            page: 1,
            size: 10000,
            survey_id: this.surveyInfo.id
          }
        }).then((data) => {
          this.allQuestion = data.results
        })

        await this.$http.get('/online_survey_question_option/', {
          params: {
            page: 1,
            size: 10000,
            survey_id: this.surveyInfo.id
          }
        }).then((data) => {
          this.allOption = data.results
        })

        await this.$http.get('/online_student_survey_question/', {
          params: {
            page: 1,
            size: 1000000,
            onlineSurvey_id: this.surveyInfo.id
          }
        }).then((data) => {
          const studentIds = []
          const studentOption = {}
          for (let i = 0; i < data.results.length; i++) {
            if (studentIds.indexOf(data.results[i].studentSurvey) < 0) {
              studentIds.push(data.results[i].studentSurvey)
            }
            if (!(data.results[i].surveyQuestion.id in studentOption)) {
              studentOption[data.results[i].surveyQuestion.id] = {}
            }
            const selectOption = JSON.parse(data.results[i].selectOption.replaceAll('\'', '"'))
            // const selectOption = eval('(' + data.results[i].selectOption + ')')
            for (let j = 0; j < selectOption.length; j++) {
              if (selectOption[j] in studentOption[data.results[i].surveyQuestion.id]) {
                studentOption[data.results[i].surveyQuestion.id][selectOption[j]] += 1
              } else {
                studentOption[data.results[i].surveyQuestion.id][selectOption[j]] = 1
              }
            }
          }
          this.studentCount = studentIds.length
          this.studentOption = studentOption
        })
      }
    },
    getPercent (questionId, code) {
      if (this.studentOption && this.studentOption[questionId]) {
        if (!(code in this.studentOption[questionId]) || this.studentCount === 0) {
          return '0%'
        } else {
          return '' + (this.studentOption[questionId][code] * 100 / this.studentCount).toFixed(2) + '%'
        }
      } else {
        return '0%'
      }
    },
    backPre() {
      this.$router.go(-1)
    }
  },
  mounted() {
    this.search()
  },
  computed: {
    managerName() {
      return this.lessonInfo.manager && this.lessonInfo.manager ? this.lessonInfo.manager.name : ''
    },
    questions () {
      const data = []
      for (let i = 0; i < this.allQuestion.length; i++) {
        const question = this.allQuestion[i]
        question.options = []
        for (let j = 0; j < this.allOption.length; j++) {
          if (this.allOption[j].surveyQuestion_id === question.id) {
            question.options.push(this.allOption[j])
          }
        }
        data.push(question)
      }
      return data
    }
  }
}
</script>

<style lang="less" scoped>
#panel {
  .panel-title {
  }
  .panel-content {
    padding: 20px 40px;
    .course_info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      .panel-title {
        p {
          display: inline-block;
          margin-right: 20px;

          &:last-child {
            color: #999;
            font-size: 16px;
          }
        }
      }
      .course_btn {
        div {
          margin-left: 20px;
          padding: 7px 20px;
          background: #73D6CA;
          color: #fff;
          border-radius: 3px;
          &:first-child {
            background: #25c7a8;
          }
          &:nth-child(2) {
            border: 1px solid #73D6CA;
            color: #73D6CA;
            background: #fff;
          }
        }
      }
    }
    .list {
      h2 {
        text-align: center;
      }
      .question-title {
        font-size: 18px;
        display: inline-block;
      }
      .question-del {
        border: 1px solid indianred;
        border-radius: 3px;
        padding: 2px 4px;
        color: indianred;
        float: right;
      }
      .question-list {
        margin: 10px 10px 30px 10px;
      }
      .question-list > li {
        font-size: 16px;
        margin: 4px;
        background-color: #eeeeee;
        input {
          margin-right: 5px;
        }
        span {
          float: right;
          color: green;
        }
      }
    }
    .footer-btn {
      text-align: center;
      .add-btn {
        padding-left: 15px;
        padding-right: 15px;
      }
    }
  }
}

.add-option {
  padding: 5px 10px;
  border: 1px solid #ccc;
  background: #eee;
  cursor: pointer;
}
.add-item {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  .item {
    .label {
      padding-left: 0;
    }
  }
}
.page-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    background: #73D6CA;
    color: #fff;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 14px;
    line-height: normal;
    cursor: pointer;
  }
}
</style>
